import React, { memo, useMemo } from 'react';
import ViewMath from '../../ViewMath';
import { TestDetailQuizModel, TestQuestionAnswer } from 'models/test-detail.model';
import DragDropComponent, { DragDropItem } from 'components/common/DragDropComponent';

interface PropTypes {
  question: TestDetailQuizModel;
  answers: TestQuestionAnswer[];
  handleUpdateQuestions: (newValue: TestDetailQuizModel) => void;
}

const getRandomAnswer = (available: string[], exclude: string[]): string => {
  const filtered = available.filter(ans => !exclude.includes(ans));
  if (filtered.length === 0) return '';
  const randIndex = Math.floor(Math.random() * filtered.length);
  return filtered[randIndex];
};

const PhuHopComponent: React.FC<PropTypes> = ({ question, answers, handleUpdateQuestions }) => {
  const { leftColumn, rightColumn } = useMemo(() => {
    const left: DragDropItem[] = [];
    const right: DragDropItem[] = [];

    const usedAnswers: string[] = [];
    const finalRightSet: DragDropItem[] = [];

    const allAnswers = question.testQuestionAnswers?.map(a => a.answerRight || '') || [];

    // Duyệt từng câu hỏi (left) để chuẩn bị cặp với right
    answers.forEach((answer, index) => {
      if (answer.answerLeft !== '') {
        left.push({
          id: `${index}`,
          text: answer.answerLeft,
        });

        let value = '';
        if (
          Array.isArray(question.userAnswer) &&
          question.userAnswer[index]
        ) {
          value = question.userAnswer[index];
        } else {
          value = getRandomAnswer(allAnswers, usedAnswers);
        }

        usedAnswers.push(value);

        finalRightSet.push({
          id: `right-${index}`,
          text: value,
        });
      }
    });

    // Bổ sung các lựa chọn còn lại chưa được dùng
    allAnswers.forEach((ans, i) => {
      if (!usedAnswers.includes(ans)) {
        finalRightSet.push({
          id: `right-${finalRightSet.length}`,
          text: ans,
        });
      }
    });

    return { leftColumn: left, rightColumn: finalRightSet };
  }, [answers, question]);

  return (
    <div className="question-content">
      <DragDropComponent leftColumn={leftColumn} rightColumn={rightColumn} question={question} handleUpdateQuestions={handleUpdateQuestions} />
    </div>
  );
};

export default memo(PhuHopComponent);
